import { gql } from "config/graphql";
import { IDisclosure, IDisclosureWithBody, IUser } from "config/types";
import { gqlQuery } from "store/apollo";

interface IDisclosureResponse {
  data: {
    disclosure: IDisclosure;
  };
}

interface IDisclosureWithBodyResponse {
  data: {
    disclosure: IDisclosureWithBody;
  };
}

interface IBusinessDisclosuresResponse {
  data: {
    businessDisclosures: IDisclosure[];
  };
}

const CORE_DISCLOSURE_FIELDS = gql`
  fragment CoreDisclosureFields on Disclosure {
    createdAt
    cta
    description
    id
    name
    slug
    version
    downloadUrl
    important
  }
`;

export const disclosureQuery = (slug: string): Promise<IDisclosureResponse> => {
  const query = gql`
    ${CORE_DISCLOSURE_FIELDS}

    query disclosure($slug: String!) {
      disclosure(slug: $slug) {
        ...CoreDisclosureFields
      }
    }
  `;

  return gqlQuery<IDisclosureResponse["data"]>({
    variables: { slug },
    query,
  });
};

export const disclosureWithBodyQuery = (slug: string): Promise<IDisclosureWithBodyResponse> => {
  const query = gql`
    ${CORE_DISCLOSURE_FIELDS}

    query disclosure($slug: String!) {
      disclosure(slug: $slug) {
        ...CoreDisclosureFields
        body
      }
    }
  `;

  return gqlQuery<IDisclosureWithBodyResponse["data"]>({
    query,
    variables: { slug },
  });
};

export const businessDisclosuresQuery = (
  businessSlug: string
): Promise<IBusinessDisclosuresResponse> => {
  const query = gql`
    ${CORE_DISCLOSURE_FIELDS}

    query BusinessDisclosures($businessSlug: String!) {
      businessDisclosures(businessSlug: $businessSlug) {
        ...CoreDisclosureFields
      }
    }
  `;
  return gqlQuery<IBusinessDisclosuresResponse["data"]>({
    query,
    variables: { businessSlug },
  });
};

interface IDocumentsResponse {
  data: {
    me: IUser;
  };
}

export const documentsQuery = (): Promise<IDocumentsResponse> => {
  const query = gql`
    query userDocuments {
      me {
        activeConstellations {
          activeInsuranceMembership {
            id
            activePolicy {
              documents {
                id
                name
                description
                cta
                slug
                html {
                  url
                  fileName
                }
                pdf {
                  url
                  fileName
                }
                version
              }
            }
            documents {
              id
              name
              description
              cta
              slug
              html {
                url
                fileName
              }
              pdf {
                url
                fileName
              }
              version
            }
          }
        }
      }
    }
  `;

  return gqlQuery<IDocumentsResponse["data"]>({ query });
};
